import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Single source of truth lives with the error taxonomy's rayId handling.
export { rayIdFromHeaders as getRayId } from '../engine/errors'

export * from './amplitude'
export * from './chat'
export * from './date'
export * from './paywallStorage'
